
import {defineComponent, PropType} from "vue";
import OptionEditoPopin from "../../../../../common/components/vue/OptionEditoPopin.vue";
import ThreeColumnsEditoPopin from "../../../../../common/components/vue/ThreeColumnsEditoPopin.vue";
import EditoPopin from "../../../../../common/components/vue/EditoPopin.vue";
import {
    OfferDetail,
    OfferEditoPopin,
    OfferOptionEditoPopin,
    OfferThreeColumnsEditoPopin,
} from "./models/SingleOfferDetail";
import EditorialPush from "../../../../../common/components/ob1/EditorialPush.vue";
import {PushZigZagDto} from "../../../../../showcase/models/OfferApiResponse";
import Price from "../../../../../common/components/ob1/Price.vue";
import GenericButtonCta from "../../../../../common/broadband/components/GenericButtonCta.vue";
import {GenericButtonCtaDto} from "../../../../../showcase/models/GenericButtonCtaDto";
import {PrixDTO} from "../../../../../../../../generated/js/OrderingDtos";

export default defineComponent( {
    name: "InternetOfferDetails",
    components: {
        GenericButtonCta,
        Price,
        EditorialPush,
        ThreeColumnsEditoPopin,
        OptionEditoPopin,
        EditoPopin
    },
    props: {
        offerName: {
            type: String,
            required: true
        },
        price: {
            type: Object as PropType<PrixDTO>,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        details: {
            type: Array as PropType<Array<OfferDetail>>,
            required: true
        },
        zigZag: {
            type: Object as PropType<PushZigZagDto> | null,
            required: false,
            default: null
        },
        genericButtonCta: {
            type: Object as PropType<GenericButtonCtaDto>,
            required: true,
        },
        editoPopins: {
            type: Array as PropType<Array<OfferEditoPopin>>,
            required: true
        },
        destinationPopin: {
            type: Object as PropType<OfferThreeColumnsEditoPopin> | null,
            required: false,
            default: null
        },
        mobileOptionPopin: {
            type: Object as PropType<OfferOptionEditoPopin> | null,
            required: false,
            default: null
        },
    },
    mounted() {
        this.addElementsForModalToggle();
    },
    updated() {
        this.addElementsForModalToggle();
    },
    methods: {
        addElementsForModalToggle() {
            const offerDetailsEl = this.$el.querySelector(".offer-details") as HTMLElement | null;
            if (!offerDetailsEl) return;

            const { oeventCategory, oeventLabel } = offerDetailsEl.dataset;

            offerDetailsEl.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
                const hrefAttr = link.getAttribute("href");
                if (hrefAttr?.startsWith("#")) {
                    link.target = "_self";
                    link.dataset.bsToggle = "modal";
                    link.dataset.oeventCategory = oeventCategory;
                    link.dataset.oeventLabel = oeventLabel;
                    link.dataset.oeventAction = hrefAttr.substring(1);
                    link.className = "ob1-link-arrow ob1-link-small ob1-link-large";
                } else {
                    link.target = "_blank";
                    link.dataset.oeventCategory = oeventCategory;
                    link.dataset.oeventLabel = "ouverture_nouvelle_fenetre";
                    link.dataset.oeventAction = hrefAttr?.substring(1);
                }
            });

            // Masquer les boutons avec data-bs-target via Vue
            offerDetailsEl.parentElement?.querySelectorAll<HTMLElement>("[data-bs-target]").forEach((element) => {
                element.classList.add("d-none");
            });
        },
    }
});
